document.addEventListener("DOMContentLoaded", () => {

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('-').map(Number);
    return Date.UTC(year, month - 1, day);
  };

  const getCurrentTimeInTimeZone = (() => {
    const timeZone = 'Europe/London';
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });

    return () => {
      const now = new Date();
      const parts = Object.fromEntries(
        formatter.formatToParts(now).map(part => [part.type, part.value])
      );
      const dateStr = `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}Z`;
      return new Date(dateStr).getTime();
    };
  })();

  const countdownElement = document.getElementById('countdown');
  const startDate = parseDate(countdownElement.getAttribute('data-start-date'));
  const targetDate = parseDate(countdownElement.getAttribute('data-end-date'));
  const now = getCurrentTimeInTimeZone();

  const showProgressContent = () => {
    const progress = document.querySelector('#progress_product_of_the_month');
    if (progress) {
      progress.style.display = 'block';
      progress.querySelector('.text').style.display = 'none';
      progress.querySelector('.filler').style.width = '0%';
      progress.querySelector('.stock').innerHTML = '0% remaining stock';
    }
  };

  if (startDate > now) {
    const progress = document.querySelector('#progress_product_of_the_month');
    if (progress) {
      progress.style.display = 'none';
    }
    return;
  }

  const countdownInterval = setInterval(() => {
    const currentDate = getCurrentTimeInTimeZone();
    const timeDifference = targetDate - currentDate;

    if (timeDifference <= 0) {
      clearInterval(countdownInterval);
      countdownElement.innerHTML = '<div class="text error-oos">Time’s up! Better luck next month!</div>';
      if (document.querySelector('.main-product-form')) {
        document.querySelector('.main-product-form').style.display = 'none';
      }
      showProgressContent();
    } else {
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      const text_days = days === 1 ? ' day' : ' days';

      countdownElement.innerHTML = 
        `${days.toString().padStart(2, '0')}${text_days} ` +
        `${hours.toString().padStart(2, '0')}:` +
        `${minutes.toString().padStart(2, '0')}:` +
        `${seconds.toString().padStart(2, '0')}`;

      if (document.querySelector('.main-product-form')) {
        document.querySelector('.main-product-form').style.display = 'block';
      }
    }
  }, 1000);
});
